import { useState, useEffect } from 'react'
import { useLocation } from '@reach/router'

export default () => {
  const [queryParams, setQueryParams] = useState({})
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search.slice(1))
    const paramsObject = Array.from(params.entries()).reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
    setQueryParams(paramsObject)
  }, [location.search])

  return queryParams
}
